module.exports = __webpack_public_path__ + "static/media/cobuy-poster.14b02864.jpg";